/**
 *
 * Asynchronously loads the component for TextContent
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SearchBar = lazyLoad(
  () => import('./index'),
  module => module.SearchBar,
);
